import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { type ErxRecommendedRetailPrice } from './priceAccessorGetErxRecommendedRetailPrice'

export const priceAccessorShouldDisplayErxRecommendedRetailPrice = ({
  currentPrescriptionType,
  erxRecommendedRetailPrice,
  isPrescriptionProduct,
}: {
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum
  erxRecommendedRetailPrice: ErxRecommendedRetailPrice | null
  isPrescriptionProduct: boolean
}): boolean => {
  if (
    isPrescriptionProduct &&
    (currentPrescriptionType ===
      PrescriptionPrescriptionTypeEnum.FreePrescription ||
      currentPrescriptionType ===
        PrescriptionPrescriptionTypeEnum.InsurancePrescription)
  ) {
    return erxRecommendedRetailPrice?.price !== undefined
  }

  return false
}
